import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'pictureLibrary',
  props: {
    pictureList: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    configData: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    subhead: String,
    pictureIndex: {
      default: function _default() {
        return 1;
      },
      type: Number
    },
    // 取组件中第几个分类图片  如果获取对应组件图库信息为多个时,需传入值,否则默认为1
    depot: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      form: {
        title: ''
      },
      searchKeyword: '',
      tabList: [{
        id: 'all',
        name: '全部'
      }],
      // 预置全部tab项
      show: true,
      iDisplayLength: 10,
      currentPage: 1,
      layout: 'total, prev, pager, next, jumper',
      currentIndex: null,
      activeTab: 'all'
    };
  },
  methods: {
    search: function search() {
      var _this$form$title = this.form.title,
        title = _this$form$title === void 0 ? '' : _this$form$title;
      this.changeTab();
      this.searchKeyword = title.trim();
    },
    changeTab: function changeTab() {
      this.currentIndex = null;
      this.pageChange(1);
    },
    selectPic: function selectPic(index) {
      this.currentIndex = (this.currentPage - 1) * this.iDisplayLength + index;
    },
    pageChange: function pageChange(val) {
      this.currentPage = val;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.iDisplayLength = val;
      this.pageChange(1);
    },
    onSubmit: function onSubmit() {
      if (typeof this.currentIndex !== 'number') {
        this.$message.error('请选择数据源');
        return;
      }
      this.$emit('onSubmit', this.currentList[this.currentIndex]);
    },
    onClose: function onClose() {
      this.$emit('onClose');
    }
  },
  created: function created() {
    var _this$tabList;
    (_this$tabList = this.tabList).push.apply(_this$tabList, _toConsumableArray(this.depot[this.pictureIndex]));
  },
  computed: {
    currentList: function currentList() {
      var _this = this;
      // 预置全部tab项
      if (this.activeTab === 'all') {
        return this.pictureList.filter(function (i) {
          return i.title.indexOf(_this.searchKeyword) > -1;
        });
      }
      var list = this.pictureList.filter(function (i) {
        return i.map_type_id === _this.activeTab && i.title.indexOf(_this.searchKeyword) > -1;
      });
      return list || [];
    },
    dataSource: function dataSource() {
      return this.currentList.slice((this.currentPage - 1) * this.iDisplayLength, this.currentPage * this.iDisplayLength);
    },
    totalRecords: function totalRecords() {
      return this.currentList.length;
    } // tabList() {
    // 	return this.depot[this.pictureIndex] || []
    // }
  }
};